import React from 'react';
import cx from './cx';

const AppSpinner = ({
  size,
  label = 'Chargement…',
  centered = true,
  className = '',
  variant = 'dark',
}) => {
  const spinner = (
    <div
      className={cx('spinner-border', size === 'sm' && 'spinner-border-sm', `text-${variant}`, className)}
      role="status"
    >
      <span className="visually-hidden">{label}</span>
    </div>
  );

  if (!centered) return spinner;
  return <div className="text-center py-5">{spinner}</div>;
};

export default AppSpinner;
